export default __webpack_public_path__ + "static/media/earth.3ee303e1.jpg";